import { Breadcrumbs, Link, Stack, TablePagination, Typography } from "@mui/material";
import { ModalCreateEquipamentoMedicao } from "./components/modal_create";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { LegendComponent } from "../../../../../common/components/legend_component";
import { LegendItemComponent } from "../../../../../common/components/legend_item_component";
import { LegendIcon } from "../../../../../common/components/legend_icon";
import { Header } from "./components/header";
import { GenerateControleColumnDefinition } from "./columns";
import { useMemo } from "react";
import { EquipamentoMedicaoList } from "../../../../equipamentoMedicoes/domain/models/EquipamentoMedicao_List";
import { useEquipamentoMedicaoListaViewModel } from "../../viewModels/EquipamentoMedicao_lista_view_model";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import { EquipamentoMedicaoHistoricoModal } from "../../../../../common/presentation/components/equipamento_medicao_historico_modal";
import { CopyEquipamentoMedicaoModal } from "./components/copy_equipamento_medicao_modal";

import DeleteDialog from "../../../../../common/components/delete_dialog";
import PrimaryButton from "../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../common/components/dynamic_icon";

export const EquipamentoMedicao_lista = () => {
  const viewModel = useEquipamentoMedicaoListaViewModel();

  const columnsDefinition = useMemo(() => {
    return GenerateControleColumnDefinition({
      onActionEditar: viewModel.handleEquipamentoMedicaoCadastroOpenState,
      onActionDeletar: viewModel.handleDeleteEquipamentoMedicaoOpenState,
      onActionCopy: viewModel.handleCopyEquipamentoMedicaoOpenState,
    });
  }, [
    viewModel.handleEquipamentoMedicaoCadastroOpenState,
    viewModel.handleDeleteEquipamentoMedicaoOpenState,
    viewModel.handleCopyEquipamentoMedicaoOpenState,
  ]);


  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2 ">

              <div className="w-[220px] ">
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                  onClick={() => viewModel.handleEquipamentoMedicaoCadastroOpenState(null, true)}>
                  Novo Equipamento
                </PrimaryButton>
              </div>
            </div>
          }
        />
      </PageTopBar>

      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Home
          </Link>
          <Typography className="text-primary-green">  Equipamentos de Medição</Typography>
        </Breadcrumbs>

        <Header
          status={viewModel.filters.status}
          equipamento={viewModel.filters.equipamento}
          responsavelPeloEquipamento={viewModel.filters.responsavelPeloEquipamento}
          dataCalibracaode={viewModel.filters.dataCalibracaoDe}
          dataCalibracaoate={viewModel.filters.dataCalibracaoAte}
          onhandleDataCalibracaoChange={viewModel.handleDataCalibracaoRangeChange}
          onEquipamentoChange={viewModel.handleEquipamentoChange}
          onResponsavelPeloEquipamentoChange={viewModel.handleResponsavelPeloEquipamentoChange}
          onStatusChange={viewModel.handleStatusChange}
          onCentroCustoChange={viewModel.handleIdsCentroCustoChange}
          idsCentroCusto={viewModel.filters.idsCentroCusto ?? []}
          centrocustoDropDown={viewModel.ddlCentroCusto ?? []}
          onClear={viewModel.handleClearFilters}
        />

        <Stack spacing={0}>
          <div className="w-full flex flex-row justify-between items-stretch">
            <div className="flex flex-col flex-wrap justify-end">
              <LegendComponent>
                <LegendItemComponent icon={<LegendIcon color="red" title="A" />} label="Atrasado" />

                <LegendItemComponent icon={<LegendIcon color="yellow" title="E" />} label="Em Dia" />
              </LegendComponent>
            </div>

            <div className="flex flex-col justify-between flex-1">
              <TablePagination
                component="div"
                count={viewModel.pagination.totalItems}
                page={viewModel.pagination.page - 1}
                onPageChange={(_, p) => viewModel.handlePageChange(p)}
                rowsPerPageOptions={[10, 25, 50, 100]}
                rowsPerPage={viewModel.pagination.rowsPerPage}
                onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
              />
            </div>
          </div>

          <StyledDataGrid
            tableName="Obras Equipamento Medicao"
            disableColumnMenu={false}
            showToolbar={true}
            disableRowSelectionOnClick={true}
            textSize="pequeno"
            getRowId={(row: EquipamentoMedicaoList) => row.idEquipMedicao}
            getRowHeight={() => 'auto'}
            columns={columnsDefinition}
            loading={viewModel.loading}
            checkboxSelection={false}
            rows={viewModel.equipamentoMedicaoLista}
            rowCount={viewModel.equipamentoMedicaoLista.length}
            pageSizeOptions={[10, 25, 50, 100]}
            paginationMode="server"
            paginationModel={{
              page: viewModel.pagination.page,
              pageSize: viewModel.pagination.rowsPerPage,
            }}
            pinnedColumns={{
              left: ["_check_"],
              right: ["idEquipMedicao"],
            }}
          />

          <div className="flex flex-col justify-between flex-1">
            <TablePagination
              component="div"
              count={viewModel.pagination.totalItems}
              page={viewModel.pagination.page - 1}
              onPageChange={(_, p) => viewModel.handlePageChange(p)}
              rowsPerPageOptions={[10, 25, 50, 100]}
              rowsPerPage={viewModel.pagination.rowsPerPage}
              onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
            />
          </div>
        </Stack>
      </div>

      <ModalCreateEquipamentoMedicao
        open={viewModel.openCreateModal}
        saving={viewModel.saving}
        selectedEquipamentoMedicao={viewModel.selectedEquipamentoMedicao}
        onClose={() => viewModel.handleEquipamentoMedicaoCadastroOpenState(null, false)}
        onSubmit={viewModel.handleEquipamentoMedicaoSubmit}
        onDownloadFile={viewModel.handleDownloadFile}
        onOpenHistory={id => viewModel.handleHistoricoEquipamentoMedicaoOpenState(id, true)}
        editmod={true}
      />

      <EquipamentoMedicaoHistoricoModal
        open={viewModel.openHistoricoModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        itens={viewModel.equipamentoMedicaoHistoricoLista}
        onClose={() => viewModel.handleHistoricoEquipamentoMedicaoOpenState(0, false)}
      />

      <CopyEquipamentoMedicaoModal
        open={viewModel.openCopyModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        funcionariosDropdown={viewModel.ddlFuncionarios}
        onClose={() => viewModel.handleCopyEquipamentoMedicaoOpenState(null, false)}
        onSubmit={viewModel.handleCopyEquipamentoMedicaoSubmit}
      />

      <DeleteDialog
        open={viewModel.openDeleteModal}
        onClose={() => viewModel.handleDeleteEquipamentoMedicaoOpenState(null, false)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleDeleteEquipamentoMedicaoSubmit}
      />

    </>
  );
};
